/**
 * Nested Partial type.
 */
export type Subset<K> = {
  [attr in keyof K]?: K[attr] extends object ? Subset<K[attr]> : K[attr];
};

/**
 * A way to validate whether an Enum complies to a Prisma Enum (which is a const).
 */
export type ValidateEnum<T, U> = {
  [K in keyof T]: K extends keyof U
    ? T[K] extends U[K]
      ? true
      : never
    : never;
};

export type ForwardReferenceWrapper<T> = T;

/**
 * Type guard to check if a value is defined (not null or undefined).
 * Can be used on maps and arrays to filter out undefined/null values.
 * .filter(isDefined);
 */
export function isDefined<T>(value: T | undefined | null): value is T {
  return value != null;
}
